import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { ThemePipe } from '../../../core/pipes/theme.pipe';
import { NgStyle } from '@angular/common';

export enum TournamentInfoItemVariant {
  Default = 'default',
  Time = 'time',
  Currency = 'currency',
  Count = 'count',
}

export interface TournamentInfoItemConfig {
  variant: TournamentInfoItemVariant;
  label: string;
  value: string | number;
  showPulse?: boolean;
}

@Component({
  selector: 'app-tournament-info-item',
  templateUrl: './tournament-info-item.component.html',
  styleUrls: ['./tournament-info-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, ThemePipe],
})
export class TournamentInfoItemComponent {
  config = input.required<TournamentInfoItemConfig>();

  readonly labelStyles: [string, string][] = [
    ['type', 'card-tournament-status-label'],
    ['text-color', 'card-tournament-status-label'],
  ];

  readonly valueStyles: [string, string][] = [
    ['type', 'card-tournament-status-value'],
    ['text-color', 'card-tournament-status-value'],
  ];
}
